export class LoginControl {
    constructor() {
        this.isLogged = this.isLogged.bind(this);
        this.tryLogin = this.tryLogin.bind(this);
        this.tryLogout = this.tryLogout.bind(this);
    }

    tryLogin(user) {
    }

    isLogged() {
        return false;
    }

    tryLogout() {
    }
}


// WEBPACK FOOTER //
// ./src/utils/AbstractLoginControl.js